"use client"

import { StytchB2BClientProvider } from "@/components/StytchB2BProvider"

export default function LoginLayout({ children }: { children: React.ReactNode }) {
    return <StytchB2BClientProvider>{children}</StytchB2BClientProvider>
}
